import { CreateSigningAppointmentFormData } from '../../04_confirmationStep/convertToCreateSigningAppointmentRequest';

export type ISignersFormData = Pick<CreateSigningAppointmentFormData, 'signers'>;

// For use in the SignersStep. This makes sure that the Formik Instance is concerned about the Signers Form.
export const buildInitialSignersFormData = (wizardFormData: CreateSigningAppointmentFormData): ISignersFormData => {
  return {
    signers: wizardFormData.signers,
  };
};
